import React, { Component, ErrorInfo } from 'react'
import { PageNotFound } from '../PageNotFound'

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
}

interface ErrorBoundaryProps {
  children: React.ReactNode
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true, error: null }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
    this.setState({ error })
  }

  render() {
    if (this.state.hasError) {
      return (
        <PageNotFound
          error={500}
          errorStack={
            this.state.error?.stack ? (
              <code>{this.state.error?.stack}</code>
            ) : undefined
          }
        />
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
